import { useLocation } from "react-router-dom";

export const useRouteManager = () => {
    const location = useLocation();
    const { search } = useLocation();

    const isCurrentRoute = (currentRoute: string) => {
        return location.pathname === currentRoute; 
    }

    const getParam = (key: string): string | null => {
        const params = new URLSearchParams(search);
        return params.get(key);
    };

    return {
        isCurrentRoute,
        getParam
    }
}